var map = {
	"./Error404.svg": "df7c",
	"./chave.svg": "f6d2",
	"./enviado.svg": "2d85",
	"./erro.svg": "cad3",
	"./logo.svg": "9b19",
	"./logo_bpo.svg": "556f",
	"./logo_new.svg": "9e60",
	"./logo_sync.svg": "4442",
	"./pattern_login.svg": "2d8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";